/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The partner type (user/guest)
 */
export enum ReleaseFormType {
    USER = 'user',
    DOCUMENT = 'document',
    GUEST = 'guest',
    LINK = 'link',
    UNKNOWN = 'unknown',
}
